define(['angular'], function(angular) {


    /**
     * @class OrderTypeService
     */
    function OrderTypeService() {
        var self = this;
        var orderTypes = [];

        self.initOrderTypes = function _initOrderTypes(orderForm) {
            orderTypes = orderForm.orderTypes;
        };

        self.getOrderTypes = function getOrderTypes() {
            return orderTypes;
        };

        /**
         * Get the orderType by its code
         * @param string orderTypeCode
         * @returns Object OrderType
         */
        self.getOrderTypeByCode = function getOrderTypeByCode(orderTypeCode) {
            return orderTypes.find(function(orderTypeObject) {
                return orderTypeObject.code === orderTypeCode;
            });
        };

        /**
         * Get a array of the codes of all the orderTypes
         * @return promise
         */
        self.getOrderTypesCodes = function getOrderTypesCodes() {
            var codes = [];

            var p = new Promise(function(resolve, reject) {
                if (orderTypes) {
                    for (var i = 0; i < orderTypes.length; i++) {
                        codes.push(orderTypes[i].code);
                    }
                    resolve(codes);
                }
            });

            return p;
        };

        /**
         * Get the orderType label for a given order
         * @param order
         * @returns string label
         */
        self.getOrderTypeLabel = function getOrderTypeLabel(order) {
            return order.orderType.label || order.orderType.orderTypeLabel;
        };

        return self;
    }

    OrderTypeService.$inject = [];

    angular.module('app.bdc.common.orderTypeService', []).factory('orderTypeService', OrderTypeService);
});
